// extracted by mini-css-extract-plugin
export default {"wrapper":"grid-list_wrapper__1OQvk","innerWrapper":"grid-list_innerWrapper__r4tyB","imgBg":"grid-list_imgBg__bjdLi","title":"grid-list_title__-pM5Q","desc":"grid-list_desc__72U4l"};